export const SET_LOADING_LIST = '@tenant/SET_LOADING_LIST';
export const SET_LOADING_DATA = '@tenant/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@tenant/SET_LOADING_SEND';

export const GET_BY_ID_REQUEST = '@tenant/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@tenant/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@tenant/SAVE_REQUEST';
export const SAVE_SUCCESS = '@tenant/SAVE_SUCCESS';

export const UPDATE_IMAGE_TENANT = '@tenant/UPDATE_IMAGE_TENANT';
export const UPDATE_IMAGE_SUBSIDIARY = '@tenant/UPDATE_IMAGE_SUBSIDIARY';

export const UPDATE_PRICE_TABLE = '@tenant/UPDATE_PRICE_TABLE';

export const GET_ALL_REQUEST = '@tenant/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@tenant/GET_ALL_SUCCESS';

export const SET_PAGE = '@tenant/SET_PAGE';
export const SET_ROWS_COUNT = '@tenant/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@tenant/SET_ROWS_PER_PAGE';
export const SET_ROWS_ORIENTATION = '@tenant/SET_ROWS_ORIENTATION';
export const SET_ORDER = '@tenant/SET_ORDER';
export const SET_ORDERBY = '@tenant/SET_ORDERBY';

export const TEST_TENANT_CONNECTION = '@tenant/TEST_TENANT_CONNECTION';
export const TEST_TENANT_CONNECTION_LOADING = '@tenant/TEST_TENANT_CONNECTION_LOADING';
